<template>
  <!--    hero-area-start-->
  <div class="hero-area" style="background-image: url(assets/img/hero-img.png)">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="hero-containt position-relative">
            <img src="assets/img/logo-dl-light.png" alt="" />
            <p>
              The rankings will be released on May 10th à 12.00 GMT
            </p>

            <div class="hero-global">
              <p>Official publication in:</p>
              <h3>
                <count-down :endDate="new Date('May 10 2022 12:00:00 GMT+0100')" />
              </h3>
              <img src="assets/img/glo-bot.png" alt="" class="glo-dot" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    hero-area-end-->
</template>

<script>
import CountDown from '@/components/CountDown';
export default {
  components: {
    CountDown
  },
  data() {
    return {
      textElements: {}
    };
  }
};
</script>

<style lang="scss" scoped>
h3,
h4 {
  margin: 0px 0px 15px;
}
</style>
